import React, { FC, useCallback, useMemo, useState } from 'react'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from 'styled-components'
import { theme } from '@elamajs/ui-kit'
import { getSvg } from '@src/containers/UtmGenerator/helpers'

import ModalForm from '../ModalForm/ModalForm'
import { VARIANT_TO_RENDER } from '../../constants'

import * as Styled from './ModalButton.styled'

type Props = {
  variant: string
  renderPlace: string
  elementId: string
}

const ModalButton: FC<Props> = ({ variant, renderPlace, elementId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  const text = useMemo(() => {
    switch (variant) {
      case VARIANT_TO_RENDER.EDTECH:
      case VARIANT_TO_RENDER.MEDICINE:
      case VARIANT_TO_RENDER.REALTY:
        return (
          <Styled.ButtonTitle>
            {getSvg('email')}
            Получить исследование
          </Styled.ButtonTitle>
        )
      case VARIANT_TO_RENDER.STATISTICS:
        return 'Получить расшифровку экспертов'
    }
  }, [variant])

  return (
    <>
      <Styled.Button onClick={handleOpenModal} variant={variant}>
        {text}
      </Styled.Button>
      <ModalForm
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
        variant={variant}
        renderPlace={renderPlace}
        elementId={elementId}
      />
    </>
  )
}

const withProviders = (Component: FC<Props>): FC<Props> => {
  const NewComponent: FC<Props> = props => {
    return (
      <ThemeProvider theme={theme}>
        <IntlProvider locale="ru">
          <Component {...props} />
        </IntlProvider>
      </ThemeProvider>
    )
  }

  return NewComponent
}

export default withProviders(ModalButton)
